import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routers from "./routers/Router";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "./components/cookies/cookies";
import CookiePreferencesModal from "./components/cookies/CookiePreferencesModal";
import CookieFloatingButton from "./components/cookies/CookieFloatingButton";

function App() {
  const [, setNonce] = useState("");
  const COOKIE_NAME = "cookie_preferences_facialsense";

  const [showCookies, setShowCookies] = useState(false);
  const [openPreferences, setOpenPreferences] = useState(false);
  const [showCookieButton, setShowCookieButton] = useState(false);

  const [preferences, setPreferences] = useState({
    functional: false,
    analytics: false,
    marketing: false,
  });

  /* ================= LOAD COOKIE ================= */
  useEffect(() => {
    const saved = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${COOKIE_NAME}=`));

    if (!saved) {
      setShowCookies(true);
      return;
    }

    try {
      const rawValue = saved.split("=")[1];
      const decoded = decodeURIComponent(rawValue); // ⭐ QUAN TRỌNG
      const parsed = JSON.parse(decoded);

      setPreferences(parsed);
      setShowCookieButton(true);
    } catch (err) {
      console.error("Cookie parse error:", err);
      setShowCookies(true);
    }
  }, []);

  /* ================= SAVE COOKIE ================= */
  const saveCookies = (prefs) => {
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
      JSON.stringify(prefs)
    )}; path=/; domain=.facialsense.mobile-id.vn; max-age=31536000; SameSite=Lax`;
  };

  /* ================= HANDLERS ================= */
  const handleAcceptAll = () => {
    const all = { functional: true, analytics: true, marketing: true };
    setPreferences(all);
    saveCookies(all);
    setShowCookies(false);
    setShowCookieButton(true);
  };

  const handleRejectAll = () => {
    const reject = { functional: false, analytics: false, marketing: false };
    setPreferences(reject);
    saveCookies(reject);
    setShowCookies(false);
    setShowCookieButton(true);
  };

  const handleSavePreferences = () => {
    saveCookies(preferences);
    setOpenPreferences(false);
    setShowCookies(false);
    setShowCookieButton(true);
  };

  useEffect(() => {
    async function fetchNonce() {
      try {
        const response = await axios.get("/auth/nonce");

        // Lấy nonce từ header X-Nonce
        const fetchedNonce = response.headers["x-nonce"];

        if (fetchedNonce) {
          setNonce(fetchedNonce);
          window.nonce = fetchedNonce;

          // Gán nonce vào meta
          document
            .getElementById("nonce-meta")
            ?.setAttribute("data-nonce", fetchedNonce);

          // Cập nhật nonce cho các script/style đã có
          document.querySelectorAll("script, style").forEach((tag) => {
            if (!tag.hasAttribute("nonce")) {
              tag.setAttribute("nonce", fetchedNonce);
            }
          });
        }
      } catch (error) {
        console.error("Lỗi lấy nonce:", error);
      }
    }

    fetchNonce();
  }, []);

  return (
    <div className="App font-montserrat">
      <BrowserRouter>
        <Routers />

        {showCookies && (
          <Cookies
            onAcceptAll={handleAcceptAll}
            onRejectAll={handleRejectAll}
            onPreferences={() => setOpenPreferences(true)}
          />
        )}

        <CookiePreferencesModal
          open={openPreferences}
          onClose={() => setOpenPreferences(false)}
          preferences={preferences}
          setPreferences={setPreferences}
          onSave={handleSavePreferences}
        />

        {showCookieButton && (
          <CookieFloatingButton
            onClick={() => setOpenPreferences(true)}
          />
        )}

        <ToastContainer
          position="bottom-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
